import { EditorStatus } from "../../../../types/EditorStatus";
import { EditorActionKey } from "../../../actions/ActionKeys";
import { EditorAction } from "../../../actions/editor";

/** Manages editor error messages. */
export const error = (
  state: string | null = null,
  action: EditorAction
): string | null => {
  switch (action.type) {
    case EditorActionKey.EDITOR_ERROR:
      return action.payload.error;
    case EditorActionKey.SET_EDITOR_STATUS:
      if (action.payload.status === EditorStatus.RUNNING) {
        return null;
      }
      return state;
    default:
      return state;
  }
};
